import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RealtimeSpaceService } from 'src/app/services/realtime-space.service';
import { RtcServiceController } from 'src/app/services/rtc.service';
import { UiService } from 'src/app/services/ui.service';
import { VideoAIService } from 'src/app/services/video-ai.service';

@Injectable()
export class ReactionsButtonStateService {
  private _showOtherParticipantsEmotes$ = new BehaviorSubject(true);
  private _autoDetectReactions$ = new BehaviorSubject(false);

  showOtherParticipantsEmotes$: Observable<boolean> = this._showOtherParticipantsEmotes$;
  autoDetectReactions$: Observable<boolean> = this._autoDetectReactions$;

  constructor(
    private videoAIService: VideoAIService,
    private rtcService: RtcServiceController,
    protected uiService: UiService,
    private realtimeSpaceService: RealtimeSpaceService,
  ) { }

  toggleOtherParticipantsEmotesVisibility(): void {
    this._showOtherParticipantsEmotes$.next(!this._showOtherParticipantsEmotes$.getValue());
  }

  toggleAutoDetectReactions() {
    this._autoDetectReactions$.next(!this._autoDetectReactions$.getValue());
    if (this._autoDetectReactions$.getValue()) {
      this.videoAIService.setGestureDetectionEnabled(true);
      if (this.rtcService.service.isCameraEnabled()) {
        this.videoAIService.start();
      }
    } else {
      this.videoAIService.setGestureDetectionEnabled(false);
    }
  }

  emote(emojiId: number) {
    this.realtimeSpaceService.service.emote(emojiId);
  }
}
